export const AIRPORTS = [
  { code: "KHI", city: "Karachi", country: "Pakistan" },
  { code: "LHE", city: "Lahore", country: "Pakistan" },
  { code: "ISB", city: "Islamabad", country: "Pakistan" },
  { code: "PEW", city: "Peshawar", country: "Pakistan" },
  { code: "UET", city: "Quetta", country: "Pakistan" },
  { code: "MUX", city: "Multan", country: "Pakistan" },
  { code: "SKT", city: "Sialkot", country: "Pakistan" },
  { code: "DXB", city: "Dubai", country: "UAE" },
  { code: "SHJ", city: "Sharjah", country: "UAE" },
  { code: "AUH", city: "Abu Dhabi", country: "UAE" },
  { code: "DOH", city: "Doha", country: "Qatar" },
  { code: "JED", city: "Jeddah", country: "Saudi Arabia" },
  { code: "RUH", city: "Riyadh", country: "Saudi Arabia" },
  { code: "MED", city: "Madinah", country: "Saudi Arabia" },
  { code: "DMM", city: "Dammam", country: "Saudi Arabia" },
  { code: "MCT", city: "Muscat", country: "Oman" },
  { code: "BAH", city: "Bahrain", country: "Bahrain" },
  { code: "KWI", city: "Kuwait City", country: "Kuwait" },
  { code: "IST", city: "Istanbul", country: "Turkiye" },
  { code: "LHR", city: "London Heathrow", country: "UK" },
  { code: "MAN", city: "Manchester", country: "UK" },
  { code: "CDG", city: "Paris", country: "France" },
  { code: "FRA", city: "Frankfurt", country: "Germany" },
  { code: "BCN", city: "Barcelona", country: "Spain" },
  { code: "JFK", city: "New York", country: "USA" },
  { code: "ORD", city: "Chicago", country: "USA" },
  { code: "YYZ", city: "Toronto", country: "Canada" },
  { code: "KUL", city: "Kuala Lumpur", country: "Malaysia" },
  { code: "BKK", city: "Bangkok", country: "Thailand" },
  { code: "BOM", city: "Mumbai", country: "India" },
];

export const airportLabel = (code) => {
  const a = AIRPORTS.find((x) => x.code === code);
  return a ? `${a.city} (${a.code})` : code;
};
